import { datadogLogs } from '@datadog/browser-logs'

let hasLoggedMissingBaseUrl = false

export const getCoreRespondentBaseUrl = (): string | undefined => {
  const baseUrl = process.env.REACT_APP_FD_CORE_RESPONDENT_URL

  if (!baseUrl) {
    // Log once per page load: every caller would otherwise silently build a
    // request against the app's own origin and fail with an opaque 404
    if (!hasLoggedMissingBaseUrl) {
      hasLoggedMissingBaseUrl = true
      datadogLogs.logger.error(
        'REACT_APP_FD_CORE_RESPONDENT_URL is not configured: requests to fd-core-respondent will fail'
      )
    }
    return undefined
  }

  // Tolerate a trailing slash in the configured value
  return baseUrl.replace(/\/+$/, '')
}

/**
 * Builds a fd-core-respondent URL from REACT_APP_FD_CORE_RESPONDENT_URL, which
 * holds the complete base URL for the service — including the gateway's
 * `/v1/core-respondent` prefix in deployed environments, and nothing but the
 * host when pointing at a locally running instance.
 *
 * @param path path on the service, starting with a slash
 */
export const coreRespondentUrl = (path: string): string => {
  const baseUrl = getCoreRespondentBaseUrl()

  return baseUrl ? `${baseUrl}${path}` : path
}
